'use strict';

module.exports = require('./lib')



//////////////////
// WEBPACK FOOTER
// ./~/fbjs/~/promise/index.js
// module id = 1751
// module chunks = 3